import { useCallback, useEffect, useState } from "react"
import SideBar from "../../../components/sidebars/settings"
import SelectableDropdown from "../../../components/profileEdit/DropDown"
import { getUserData, updateUserProfile } from "../../../apis/editProfile"
import { fetchAllCastsByReligionId, fetchAllReligions } from "../../../apis/religions"
import { useDispatch, useSelector } from 'react-redux';
import { setUserProfileDetails } from '../../../redux/slice/userProfile';
import { Select } from "antd"
import { toast } from "react-toastify"
import * as Yup from 'yup'
import { differenceInYears, formatISO, parseISO } from 'date-fns';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { basicInformation } from "../../../utils/validations/editProfile"
import ProfileEditNav from '../../../components/NavbarAndTabs/profileEdit'
import avatar from "../../../assets/profileEdit/basic/avaatar.png"

// Const Data
import { couplesMartialStatusOPtions, genderOptions, lookingForOptions, lookingForOptionsCouples, relationshipStatusOptions, singlesMartialStatusOPtions, timeLineOptions } from "utils/constant/user/profileInfo";

// Icons
import maleIcon from '../../../assets/profileEdit/basic/genderMaleIcon.svg'
import femaleIcon from '../../../assets/profileEdit/basic/genderFemaleIcon.svg'
import singlesIcon from '../../../assets/profileEdit/basic/singlesIcon.svg'
import couplesIcon from '../../../assets/profileEdit/basic/couplesIcon.svg'
import marriageIcon from '../../../assets/profileEdit/basic/marriageIcon.svg'
import datingIcon from '../../../assets/profileEdit/basic/datingIcon.svg'
import friendshipIcon from '../../../assets/profileEdit/basic/friendshipIcon.svg'
import imNotSureYetIcon from '../../../assets/profileEdit/basic/imNotSureYet.svg'
import timeLineIcon from '../../../assets/profileEdit/basic/timeLineIcon.svg'
import contactModeIcon from '../../../assets/profileEdit/basic/contactModeIcon.svg'
import religionIcon from '../../../assets/profileEdit/basic/religionIcon.svg'
import castIcon from '../../../assets/profileEdit/basic/castIcon.svg'

function Index() {
    const userInfo = useSelector((state) => state.userProfile);

    const dispatch = useDispatch();
    const { Option } = Select;

    const [religionsAndCasts, setReligionsAndCasts] = useState({
        religions: [],
        selectedReligion: null,
        casts: [],
        selectedCast: null,
    })

    const [userData, setUserData] = useState({
        personal: {
            religion_id: null,
            caste_id: null,
            sex: null,
            looking_for: null,
            detailed_bio: null,
            dob: null,
            relationship_status: null,
            marital_status: null,
            timeline: null,
        },
        name: null,
        contact_mode: null,
        photo: null,
        profile_completion: null,
    })

    const handleGetUserData = async () => {
        try {
            const res = await getUserData()
            const data = res?.data
            dispatch(setUserProfileDetails(data))
            setUserData({
                personal: {
                    religion_id: data?.personal?.religion_id?._id,
                    caste_id: data?.personal?.caste_id?._id,
                    sex: data?.personal?.sex,
                    looking_for: data?.personal?.looking_for,
                    detailed_bio: data?.personal?.detailed_bio,
                    dob: data?.personal?.dob,
                    relationship_status: data?.personal?.relationship_status,
                    marital_status: data?.personal?.marital_status,
                    timeline: data?.personal?.timeline,
                    college: data?.personal?.college,
                    education: data?.personal?.education,
                    profession: data?.personal?.profession,
                    height: data?.personal?.height,
                    weight: data?.personal?.weight,
                    physical_status: data?.personal?.physical_status,
                },
                name: data?.name,
                contact_mode: data?.contact_mode,
                photo: data?.photo,
                profile_completion: data?.profile_completion,
            })

            if (data?.personal?.religion_id?._id) {
                await handelGetAllCastsByReligionId(data?.personal?.religion_id?._id)
            }
        } catch (error) {
            toast.error("Something went wrong")
        }
    }

    const handelGetAllReligions = async () => {
        const res = await fetchAllReligions()
        setReligionsAndCasts(prev => ({ ...prev, religions: res?.data }))
    }

    const handelGetAllCastsByReligionId = async (id) => {
        const res = await fetchAllCastsByReligionId(id)
        setReligionsAndCasts(prev => ({ ...prev, casts: res?.data }))
    }

    useEffect(() => {
        handleGetUserData()
        handelGetAllReligions()
    }, [])

    // Gender
    const genderIcons = { male: maleIcon, female: femaleIcon }
    // Relationship Status
    const relationshipStatusIcons = { single: singlesIcon, couple: couplesIcon }
    // Looking For
    const lookingForIcons = { marriage: marriageIcon, dating: datingIcon, friendship: friendshipIcon, im_not_sure_yet: imNotSureYetIcon }
    // TimeLine
    const timeLineIcons = { sixMonths: timeLineIcon }
    // Religion
    const religionIcons = { religion: religionIcon }
    const religionOptions = religionsAndCasts?.religions?.map(religion => ({
        label: religion?.name,
        value: religion?.id
    }));
    // Cast
    const castIcons = { cast: castIcon }
    const castOptions = religionsAndCasts?.casts ? religionsAndCasts?.casts?.map(cast => ({
        label: cast?.name,
        value: cast?.id
    })) : []


    // Handle Change
    const handleChange = useCallback(async (inputKey, value) => {
        if (['religion_id', 'caste_id', 'sex', 'looking_for', 'detailed_bio', 'age', 'relationship_status', 'marital_status', 'timeline'].includes(inputKey)) {
            if (inputKey === 'religion_id') {
                await handelGetAllCastsByReligionId(value);
            }
            setUserData(prev => ({
                ...prev,
                personal: {
                    ...prev.personal,
                    [inputKey]: value
                }
            }));
        } else {
            setUserData(prev => ({
                ...prev,
                [inputKey]: value
            }));
        }
    }, []);


    const handleSave = async () => {
        try {
            const toastId = toast.loading("updating profile")
            const { photo, profile_completion, ...other } = userData
            await basicInformation.validate(other, { abortEarly: false });
            const res = await updateUserProfile(other)
            dispatch(setUserProfileDetails(res?.data))
            toast.dismiss(toastId)
        } catch (error) {
            toast.dismiss()
            if (error instanceof Yup.ValidationError) {
                toast.error(error.inner[0].message);
            } else {
                toast.error('Something went wrong');
            }
        }
    }

    // Calculate the Age
    function calculateAge(dob) {
        if (dob) {

            const dobDate = parseISO(dob);
            const now = new Date();
            return differenceInYears(now, dobDate);
        } else {
            return ''
        }
    }

    // Handle Age change
    const [showDatePicker, setShowDatePicker] = useState(false);
    const handleChangeAge = (value) => {
        const formattedDate = formatISO(value, { representation: 'date' });
        setUserData((prevUserData) => ({
            ...prevUserData,
            personal: {
                ...prevUserData.personal,
                dob: formattedDate,
            },
        }));
    };


    return (
        <div>
            <div className="flex flex-col h-full">

                {/* Content Area */}
                <div className="flex flex-1 overflow-hidden">
                    {/* Sidebar */}
                    <div className="hidden w-2/12 border-e-2 bg-[#edf0f7] border-e-gray-300 lg:block">
                        <SideBar />
                    </div>

                    <div className="flex flex-col w-full h-full lg:w-10/12 ">
                        <div className="w-[98%] ms-2 ">
                            <ProfileEditNav />
                        </div>
                        {/* Upper Content */}
                        <div className="flex-1 p-4 overflow-auto">
                            <div className="flex flex-col md:flex-col lg:flex-row max-h-full lg:max-h-[440px] overflow-hidden">
                                {/* Image Container */}
                                {/* Image Container with 16/9 Aspect Ratio */}
                                <div className="flex justify-center mx-5 mb-4 lg:mx-5 lg:mb-0 ">
                                    <img src={userData.photo ? userData.photo : avatar} alt="User Profile" className="max-w-[360px] max-h[510px] min-w-[360px] min-h[510px]" />
                                </div>


                                {/* Text Content Container */}
                                <div className="flex flex-col ">
                                    <div className="relative">
                                        <p className="text-xl font-semibold text-black">Bio</p>
                                        <p className="my-3 text-gray-500">Write a fun and punchy Bio introduction</p>
                                        <textarea
                                            className="relative  text-black bg-white w-full md:w-full lg:w-[699px] h-[200px] border focus:outline-none resize-none"
                                            value={userData?.personal?.detailed_bio}
                                            onChange={(e) => handleChange('detailed_bio', e.target.value)}
                                        >
                                        </textarea>

                                        {/* <div className="absolute right-[2%] top-[89%] text-sm text-black">
                                            {userData?.personal?.detailed_bio?.length || 0}/500
                                        </div> */}
                                    </div>
                                    <div className="justify-between mt-4 text-black lg:mt-28">
                                        <div className="flex justify-between max-w-full lg:max-w-[699px]">
                                            <p>Completed</p>
                                            <p className="text-[#6161f8]">{parseInt(userData?.profile_completion)}%</p>
                                        </div>
                                        <div className="w-full mt-2 bg-gray-200 rounded-3xl">
                                            <div className="bg-[#6161f8] text-xs leading-none py-1 text-center rounded-3xl  w-full md:w-full lg:max-w-[699px]" style={{ width: `${userData?.profile_completion}%` }}></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Lower Content */}
                        <div className="flex-1 p-4 overflow-auto">
                            <div className="flex flex-wrap justify-around w-full">
                                {/* Left Section */}
                                <div className="md:w-[48%] w-full">
                                    <div className="w-full p-0 text-black lg:p-4 lg:w-9/12">
                                        {/* Name */}
                                        <div className="flex text-gray-600">
                                            <svg width="24" height="24" className="mb-3 me-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M11.695 12.9961C8.08384 12.9961 5 13.5421 5 15.7287C5 17.9153 8.06427 18.4808 11.695 18.4808C15.3061 18.4808 18.3891 17.934 18.3891 15.7482C18.3891 13.5625 15.3257 12.9961 11.695 12.9961Z" stroke="#757575" stroke-width="1.61299" stroke-linecap="round" stroke-linejoin="round" />
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M11.6957 11.3944C14.0655 11.3944 15.9862 9.47281 15.9862 7.10302C15.9862 4.73323 14.0655 2.8125 11.6957 2.8125C9.32594 2.8125 7.40432 4.73323 7.40432 7.10302C7.39632 9.46481 9.3046 11.3864 11.6655 11.3944H11.6957Z" stroke="#757575" stroke-width="1.61299" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                            Name
                                        </div>
                                        <input type="text"
                                            className="block w-full p-3 bg-white border border-gray-300 rounded-sm ps-4"
                                            value={userData?.name}
                                            onChange={(e) => setUserData(prev => ({ ...prev, name: e.target.value }))}
                                            readOnly={userInfo?.verification?.status === "verified" ? true : false}
                                        />

                                        {/* Gender */}
                                        <SelectableDropdown
                                            title="Gender"
                                            icons={genderIcons}
                                            values={genderOptions}
                                            handleChangeFunction={handleChange}
                                            inputKey='sex'
                                            selectedValue={userData?.personal?.sex}
                                            readOnly={userInfo?.verification?.status === "verified" ? true : false}
                                        />
                                        {/* Age */}
                                        <div className="flex mt-7">
                                            <button
                                                onClick={() => setShowDatePicker(!showDatePicker)}
                                            >
                                                <svg width="24" height="24" className="mb-3 me-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M8 13.8845C7.79333 13.8845 7.61333 13.8079 7.46 13.6545C7.30667 13.5012 7.23 13.3212 7.23 13.1145C7.23 12.9079 7.30667 12.7282 7.46 12.5755C7.61333 12.4222 7.79333 12.3455 8 12.3455C8.20667 12.3455 8.38667 12.4222 8.54 12.5755C8.69333 12.7289 8.77 12.9089 8.77 13.1155C8.77 13.3215 8.69333 13.5012 8.54 13.6545C8.38667 13.8079 8.20667 13.8845 8 13.8845ZM12 13.8845C11.7933 13.8845 11.6133 13.8079 11.46 13.6545C11.3067 13.5012 11.23 13.3212 11.23 13.1145C11.23 12.9079 11.3067 12.7282 11.46 12.5755C11.6133 12.4222 11.7933 12.3455 12 12.3455C12.2067 12.3455 12.3867 12.4222 12.54 12.5755C12.6933 12.7289 12.77 12.9089 12.77 13.1155C12.77 13.3215 12.6933 13.5012 12.54 13.6545C12.3867 13.8079 12.2067 13.8845 12 13.8845ZM16 13.8845C15.7933 13.8845 15.6133 13.8079 15.46 13.6545C15.3067 13.5012 15.23 13.3212 15.23 13.1145C15.23 12.9079 15.3067 12.7282 15.46 12.5755C15.6133 12.4222 15.7933 12.3455 16 12.3455C16.2067 12.3455 16.3867 12.4222 16.54 12.5755C16.6933 12.7289 16.77 12.9089 16.77 13.1155C16.77 13.3215 16.6933 13.5012 16.54 13.6545C16.3867 13.8079 16.2067 13.8845 16 13.8845ZM5.615 20.9995C5.155 20.9995 4.771 20.8455 4.463 20.5375C4.15433 20.2289 4 19.8445 4 19.3845V6.61453C4 6.15453 4.15433 5.77053 4.463 5.46253C4.771 5.15386 5.155 4.99953 5.615 4.99953H7.385V2.76953H8.462V4.99953H15.615V2.76953H16.615V4.99953H18.385C18.845 4.99953 19.229 5.15386 19.537 5.46253C19.8457 5.77053 20 6.15453 20 6.61453V19.3845C20 19.8445 19.846 20.2285 19.538 20.5365C19.2293 20.8452 18.845 20.9995 18.385 20.9995H5.615ZM5.615 19.9995H18.385C18.5383 19.9995 18.6793 19.9355 18.808 19.8075C18.936 19.6789 19 19.5379 19 19.3845V10.6145H5V19.3845C5 19.5379 5.064 19.6789 5.192 19.8075C5.32067 19.9355 5.46167 19.9995 5.615 19.9995ZM5 9.61453H19V6.61453C19 6.4612 18.936 6.3202 18.808 6.19153C18.6793 6.06353 18.5383 5.99953 18.385 5.99953H5.615C5.46167 5.99953 5.32067 6.06353 5.192 6.19153C5.064 6.3202 5 6.4612 5 6.61453V9.61453Z" fill="#757575" />
                                                </svg>
                                            </button>
                                            Age
                                        </div>
                                        <label className="block w-full p-3 border border-gray-300 rounded-sm ps-4" onClick={() => setShowDatePicker(!showDatePicker)}>{calculateAge(userData?.personal?.dob)}</label>
                                        {showDatePicker && (
                                            <DatePicker
                                                selected={userData?.personal?.dob ? new Date(userData.personal.dob) : null}
                                                onChange={handleChangeAge}
                                                className="block w-full p-3 border border-gray-300 rounded-sm ps-4"
                                                dateFormat="yyyy-MM-dd"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setShowDatePicker(false);
                                                    }
                                                }}
                                                readOnly={userInfo?.verification?.status === "verified" ? true : false}
                                            />
                                        )}

                                        {/* Relationship status */}
                                        <SelectableDropdown
                                            title="Relationship status"
                                            icons={relationshipStatusIcons}
                                            values={relationshipStatusOptions}
                                            handleChangeFunction={handleChange}
                                            inputKey='relationship_status'
                                            selectedValue={userData.personal.relationship_status}
                                        />
                                        {/* Martial Status */}
                                        <div className="flex flex-col w-full mt-3 space-y-3">
                                            {(userData.personal.relationship_status === 'single' ? singlesMartialStatusOPtions : couplesMartialStatusOPtions).map((label, index) => (
                                                <label
                                                    key={index}
                                                    onClick={() => handleChange('marital_status', label.value)}
                                                    className={`p-3 w-full text-center text-black border border-gray-300 rounded-md cursor-pointer 
                                                    ${userData.personal.marital_status === label.value ? 'text-brandRed border border-red-400' : ' text-black border border-gray-300'}`}
                                                >
                                                    {label.label}
                                                </label>
                                            ))}
                                        </div>
                                        {/* Looking For */}
                                        <SelectableDropdown
                                            title="Looking For"
                                            icons={lookingForIcons}
                                            values={userData.personal.relationship_status === 'single' ? lookingForOptions : lookingForOptionsCouples}
                                            handleChangeFunction={handleChange}
                                            inputKey='looking_for'
                                            selectedValue={userData.personal.looking_for}
                                        />
                                        {/* Time Line */}
                                        {userData?.personal.relationship_status === 'single' &&
                                            <SelectableDropdown
                                                title="Timeline"
                                                icons={timeLineIcons}
                                                values={timeLineOptions}
                                                handleChangeFunction={handleChange}
                                                inputKey='timeline'
                                                selectedValue={userData.personal.timeline}
                                            />
                                        }
                                    </div>
                                </div>
                                {/* Right Section */}
                                <div className="md:w-[48%] w-full -mt-6 flex justify-end me-0 lg:me-10">
                                    <div className="w-full p-0 text-black lg:p-4 lg:w-9/12">
                                        {/* Religion */}
                                        {userData.personal.relationship_status === 'single' &&
                                            <>
                                                <SelectableDropdown
                                                    title="Religion"
                                                    icons={religionIcons}
                                                    values={religionOptions}
                                                    handleChangeFunction={handleChange}
                                                    inputKey='religion_id'
                                                    selectedValue={userData.personal.religion_id}
                                                    readOnly={userInfo?.verification?.status === "verified" ? true : false}
                                                />
                                                {/* Cast */}
                                                <SelectableDropdown
                                                    title="Caste"
                                                    icons={castIcons}
                                                    values={castOptions.map(option => ({
                                                        ...option,
                                                        label: option.label
                                                            .split('-')
                                                            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                                            .join(' ')
                                                    }))}
                                                    handleChangeFunction={handleChange}
                                                    inputKey='caste_id'
                                                    selectedValue={userData.personal.caste_id}
                                                    readOnly={userInfo?.verification?.status === "verified" ? true : false}
                                                />
                                            </>
                                        }
                                        {/* Contact Mode */}
                                        <div className='flex mt-7'>
                                            <img src={contactModeIcon} alt="icon" className="mb-3 me-1" />
                                            <span>Contact Mode</span>
                                        </div>
                                        <div className="block w-full p-2 border border-gray-300 rounded-sm">
                                            <Select
                                                mode="multiple"
                                                style={{ width: '100%' }}
                                                placeholder="Choose.."
                                                className="custom-select P-[3px] text-black"
                                                onChange={(selectedValues) => handleChange('contact_mode', selectedValues)}
                                                value={userData.contact_mode}
                                            >
                                                <Option value="phone">Phone</Option>
                                                <Option value="email">Email</Option>
                                                {/* <Option value="inPerson">In Person</Option> */}
                                            </Select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="flex justify-start items-start pt-4 w-full lg:w-[34%] md:w-[48%]  lg:ms-6">
                                <button className="block w-full p-3 text-white border rounded-sm ps-4 bg-brandRed" onClick={handleSave}>
                                    Save
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}
export default Index